module.exports = __webpack_public_path__ + "c538cfb601b6fe0ef21c8b8fa77ccb1c.png";